import { reactive, onMounted, onUnmounted } from 'vue'

/**
 * Create a filter state for all the things a single filter needs to communicate and filter in a general way.
 * name is not important other than it needs to be unique
 *
 * @param {object} store
 * @param {string} name
 * @returns object
 */
export default function useFilterBase(store) {
    const filterState = reactive({
        // computed
        isModified: false,
        isActive: false,
        // functions
        save: null,
        clear: null,
        // perform filtering rules and return bool to indicate if the passed item is shown
        filterItem: null,
    })

    // get an id and save it in the state
    onMounted(() => {
        store.commit('addFilterState', filterState)
    })

    onUnmounted(() => {
        store.commit('removeFilterState', filterState)
    })

    return {
        filterState,
    }
}
